import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';

import { TokenService } from '@app/auth/services/token.service';
import { AuthDOS } from '@app/auth/services/auth-dos.service';
import { ILink } from '@app/models/links';
import { AbstractSubscriptionManager } from '@app/shared/classes/subscription-manager';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutComponent extends AbstractSubscriptionManager implements OnInit {
  user = this._authDOS.getUserSnapshot();
  emailFromToken: string = null;
  links$: Observable<ILink[]> = this._authDOS.menuLinks$;

  constructor(private _authDOS: AuthDOS, private _tokenService: TokenService) {
    super();
  }

  ngOnInit(): void {
    if (!this.user) {
      this.emailFromToken = this._tokenService.composeEmailFromToken();
    }
  }
}
